export default __webpack_public_path__ + "static/media/aroma29.925ac196.png";